<template>
    <div>
        <v-tabs vertical class="overflow-fix">
            <v-tab class="d-flex justify-start text-wrap text-left">
                {{ $t("userProfileLabel") }}
            </v-tab>
            <v-tab class="d-flex justify-start text-wrap text-left">
                {{ $t("listOfOrdersLabel") }}
            </v-tab>
            <v-tab class="d-flex justify-start text-wrap text-left">
                {{ $t("listOfProductsLabel") }}
            </v-tab>

            <v-tab-item>
                <v-card class="pl-9" flat>
                    <v-card-text class="pa-0">
                        <div class="d-flex align-center mb-5 justify-center">
                            <div class="black--text text-h5 text-center">{{ $t("userProfileLabel") }}</div>
                        </div>
                    </v-card-text>
                    <UserProfile v-bind:userId="parseInt(this.$route.params.userId)" />
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card class="pl-9" flat>
                    <v-card-text class="pa-0">
                        <div class="d-flex align-center mb-5 justify-center">
                            <div class="black--text text-h5 text-center">{{ $t("listOfOrdersLabel") }}</div>
                        </div>
                    </v-card-text>
                    <OrdersTable 
                    v-bind:companyId="0" 
                    v-bind:userId="parseInt(this.$route.params.userId)" 
                    v-bind:canEdit="true" 
                    v-bind:getByUser="true" 
                    v-bind:getByCompany="false"/>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card class="pl-9" flat>
                    <v-card-text class="pa-0">
                        <div class="d-flex align-center mb-5 justify-center">
                            <div class="black--text text-h5 text-center">{{ $t("listOfProductsLabel") }}</div>
                        </div>
                    </v-card-text>
                    <ProductConfigurationsTable 
                        v-bind:companyId="parseInt(0)" 
                        v-bind:userId="parseInt(this.$route.params.userId)" 
                        v-bind:canAddNew="false"
                        v-bind:canEdit="true"
                        v-bind:getByUser="true" 
                        v-bind:getByCompany="false"/>
                </v-card>
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
import UserProfile from '../../components/UserProfile';
import ProductConfigurationsTable from '../../components/ProductConfigurationsTable';
import OrdersTable from '../../components/OrdersTable';

export default {
    components : {
        UserProfile,
        ProductConfigurationsTable,
        OrdersTable
    },
}
</script>